var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import Wrapper from "../Wrapper";
import { StyledRouterLink, StyledIconText } from "./styled";
import SecondaryDetailsItem from "../Item";
var Cashback = /** @class */ (function (_super) {
    __extends(Cashback, _super);
    function Cashback() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Cashback.prototype.render = function () {
        var _a = this.props, className = _a.className, data = _a.data;
        var apps = this.context.apps;
        var redemptionUuid = data.redemptionUuid, orderTotal = data.orderTotal;
        var idNamespace = id("secondary-details-spend", this.props);
        var orderTotalText;
        if (orderTotal) {
            var value = orderTotal.value, currency = orderTotal.currency;
            if (value && currency) {
                orderTotalText = (React.createElement(FormattedMessage, { id: "wallet.secondaryDetails.spend.orderTotal", values: {
                        amount: this.props.intl.formatNumber(value, { style: "currency", currency: currency })
                    } }));
            }
        }
        return (React.createElement(Wrapper, { className: className, id: idNamespace },
            orderTotalText && React.createElement(SecondaryDetailsItem, { isFirstItem: true, text: orderTotalText }),
            redemptionUuid &&
                React.createElement(StyledRouterLink, { app: apps.PERKS, to: "/account/my-perks?redemptionUuid=" + redemptionUuid, id: id("my-perks-button", idNamespace), uppercase: false },
                    React.createElement(StyledIconText, { icon: "angleRight", iconPosition: "right" },
                        React.createElement(FormattedMessage, { id: "wallet.secondaryDetails.spend.myPerksButtonText" })))));
    };
    Cashback.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return Cashback;
}(PureComponent));
export default injectIntl(Cashback);
